import { useState, useEffect } from "react";
import { _single_business_data } from "../common/axios_services";

export const useBusinessData = ({ businessId, businessType }) => {
  const [businessData, setBusinessData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBusiness = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await _single_business_data({
        id: businessId,
        type: businessType,
      });
      const business = response.data.data;
      setBusinessData(business);
    } catch (err) {
      console.log({ err });
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (businessId) {
      fetchBusiness();
    }
  }, [businessId, businessType]);

  return {
    businessData,
    loading,
    error,
    refetch: () => fetchBusiness(businessId),
  };
};
